require('ng-currency');
var keycode = require('keycode');


var module =  angular.module("app.directives");

module.directive('numberInput', function(){
  return {
    restrict: 'E',
    scope: {},
    replace:true,
    require: 'ngModel',
    template: '<input type="text" class="form-control number-control" ng-blur="blur()"/>',
    link: function(scope, element, attrs, ngModel){

      ngModel.$parsers.push(function (inputValue) {
        var undef = typeof inputValue == 'undefined' || inputValue == null
        var val = undef ? '' : inputValue.toString()

        val = val.replace(/[^0-9]+/g, "");

        var intVal = parseInt(val);
        if (isNaN(intVal) || undef) {
          intVal = null;
        }

        ngModel.$setViewValue(intVal);
        ngModel.$render();
        return intVal;
      });

      if (attrs.$attr.percentage) {
        ngModel.$formatters.push(function(val){
          return val !== null ? val + '%' : '';
        })
      }


      scope.blur = function(){
        var val = ngModel.$viewValue;
        var undef = typeof val == 'undefined' || val == null || val === ""
        if (undef) return;

        var intVal = parseInt(val);
        if (isNaN(intVal)) {
          intVal = null;
        }

        if (intVal !== null && intVal > attrs.max) {
          intVal = parseInt(attrs.max);
        }

        if (intVal !== null && intVal < attrs.min) {
          intVal = parseInt(attrs.min);
        }

        ngModel.$setViewValue(intVal);
        ngModel.$render();

        if (attrs.$attr.percentage) {
          element.val(element.val() + '%');
        }
      }

    }
  }
})
